module.exports = __webpack_public_path__ + "assets/8abeb104dc7e154d7abbaac02b619a7b.jpg";